import InfoPopover from "../infoPopover/infoPopover"
import { useLanguage } from "../../contexts/LanguageContext"

/**
 * Checkbox component with default value handling.
 * Manages boolean state with fallback to element default.
 * @param {Object} props
 * @param {Object} props.element - Configuration element
 * @param {Object} props.parameters - Current parameters state
 * @param {Function} props.setParameters - Function to update parameters
 * @returns {JSX.Element}
 */
function Checkbox({ element, parameters, setParameters }) {
  const { t } = useLanguage()
  const checked = !parameters || parameters[element.id] === undefined ? element.default : parameters[element.id]

  /**
   * Updates checkbox state in parameters.
   * @param {Event} e
   */
  const handleChange = e => {
    setParameters({ ...parameters, [element.id]: e.target.checked })
  }

  return (
    <div className="row checkboxRow">
      <div className="col-5 d-flex justify-content-end align-items-center">
        {element?.label ? t(element.label) : element?.label}
        <InfoPopover element={element} />
      </div>
      <div className="col d-flex align-items-center">
        <input type="checkbox" id={`input-${element.id}`} checked={!!checked} onChange={handleChange} className="checkboxRow" />
      </div>
    </div>
  )
}

export default Checkbox
